// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5NiA4MiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTg5LjEsMEg2LjNDMi44LDAsMCwyLjgsMCw2LjNjMCwzLjUsMi44LDYuMyw2LjMsNi4zSDE4djY4LjZoNTkuM3YtNi4zVjEyLjVoMTEuOGMzLjUsMCw2LjMtMi44LDYuMy02LjNDOTUuNCwyLjgsOTIuNiwwLDg5LjEsMHogTTY0LjgsNjguNkgzMC42di01NmgzNC4yVjY4LjZ6Ii8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-photo {
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.srprs-photo.blur-mobile {
  filter: blur(10px);
}
.srprs-photo.type-vignet:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  height: 35%;
  width: 100%;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.3) 100%); /* unfortunately need to to use "0,0,0,0/1" for this, to prevent displaying a very ugly gradient */
}
.srprs-photo img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.srprs-photo i {
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
  z-index: 1;
  background-size: cover;
  background-position: center center;
}
.srprs-photo.retina i {
  background-size: 45%;
  background-repeat: no-repeat;
}
.srprs-photo figcaption {
  position: absolute;
  right: 12px;
  bottom: 12px;
  z-index: 2;
  padding-left: 32px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* file size: 0.3ko | optimized file size: 0.2ko | base64 size: 0.3ko - BOOMSHAKALAKA! :D */
  background-repeat: no-repeat;
  background-position: 0 50%;
  background-size: 22px;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 13px;
  font-weight: bold;
  line-height: 1em;
  color: #fff;
  text-transform: lowercase;
  text-align: left;
}
.srprs-photo .dot:before {
  content: ".";
}

@media screen and (min-width: 768px) {
  .srprs-photo.blur-mobile {
    filter: blur(0px);
  }
  .srprs-photo figcaption {
    right: 16px;
    bottom: 16px;
    padding-left: 40px;
    background-size: 30px;
    font-size: 16px;
  }
}
@media screen and (min-width: 1024px) {
  .srprs-photo figcaption {
    right: 32px;
    bottom: 32px;
    padding-left: 48px;
    background-size: 34px;
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Photo/Photo.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AApMA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AAsMF;AArME;EACE,kBAAA;AAuMJ;AApMI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EAEE,2FAAA,EAIG,kGAAA;AAiMX;AA7LE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA+LJ;AA7LE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EAEE,sBAAA;EACA,kCAAA;AA8LN;AA1LI;EAEI,oBAAA;EACA,4BAAA;AA2LR;AAvLE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EAEE,kBAAA;EAGA,yDAAA,EAAA,2FAAA;EACA,4BAAA;EACA,0BAAA;EACA,qBAAA;EAGA,2IAAA;EACA,eAAA;EACA,iBAAA;EAEF,gBAAA;EACA,WAAA;EAEE,yBAAA;EACA,gBAAA;AAkLN;AA9KI;EACE,YAAA;AAgLN;;AC9PI;EDqFA;IACE,iBAAA;EA6KJ;EA3KE;IACE,WAAA;IACA,YAAA;IAEE,kBAAA;IAGA,qBAAA;IAGA,eAAA;EAwKN;AACF;AC3QI;ED0GA;IACE,WAAA;IACA,YAAA;IAEE,kBAAA;IAGA,qBAAA;IAGA,eAAA;EA+JN;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","$cdn-url: 'https://store.cdn.srprs.me/';\n@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.srprs-photo {\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n  &.blur-mobile {\n    filter: blur(10px);\n  }\n  &.type-vignet {\n    &:after {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      z-index: 1;\n      height: 35%;\n      width: 100%;\n      background: {\n        image: linear-gradient(\n          to bottom,\n          rgba(0, 0, 0, 0) 40%,\n          rgba(0, 0, 0, 0.3) 100%\n        ); /* unfortunately need to to use \"0,0,0,0/1\" for this, to prevent displaying a very ugly gradient */\n      }\n    }\n  }\n  img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  i {\n    width: 100%;\n    height: 100%;\n    display: block;\n    position: relative;\n    z-index: 1;\n    background: {\n      size: cover;\n      position: center center;\n    }\n  }\n  &.retina {\n    i {\n      background: {\n        size: 45%;\n        repeat: no-repeat;\n      }\n    }\n  }\n  figcaption {\n    position: absolute;\n    right: 12px;\n    bottom: 12px;\n    z-index: 2;\n    padding: {\n      left: 32px;\n    }\n    background: {\n      image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5NiA4MiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTg5LjEsMEg2LjNDMi44LDAsMCwyLjgsMCw2LjNjMCwzLjUsMi44LDYuMyw2LjMsNi4zSDE4djY4LjZoNTkuM3YtNi4zVjEyLjVoMTEuOGMzLjUsMCw2LjMtMi44LDYuMy02LjNDOTUuNCwyLjgsOTIuNiwwLDg5LjEsMHogTTY0LjgsNjguNkgzMC42di01NmgzNC4yVjY4LjZ6Ii8+PC9zdmc+); /* file size: 0.3ko | optimized file size: 0.2ko | base64 size: 0.3ko - BOOMSHAKALAKA! :D */\n      repeat: no-repeat;\n      position: 0 50%;\n      size: 22px;\n    }\n    font: {\n      family: font(body);\n      size: 13px;\n      weight: bold;\n    }\n    line-height: 1em;\n    color: color(white);\n    text: {\n      transform: lowercase;\n      align: left;\n    }\n  }\n  .dot {\n    &:before {\n      content: '.';\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-photo {\n    &.blur-mobile {\n      filter: blur(0px);\n    }\n    figcaption {\n      right: 16px;\n      bottom: 16px;\n      padding: {\n        left: 40px;\n      }\n      background: {\n        size: 30px;\n      }\n      font: {\n        size: 16px;\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-landscape) {\n  .srprs-photo {\n    figcaption {\n      right: 32px;\n      bottom: 32px;\n      padding: {\n        left: 48px;\n      }\n      background: {\n        size: 34px;\n      }\n      font: {\n        size: 18px;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
